import PostResponse from "data/PostResponse";

export const isSuccessStatus = <T>(response: PostResponse<T>): boolean => {
  return response.status < 300;
};
